import React from "react";
import Image from "next/image";
import TalkToExpertStripButton from "@/components/ui/TalkToExpertStripButton";
import { ROOT_URL } from "@/utils/gloableVariables";

export default function StartSIPStrip({ className }: { className?: string }) { 

  return (
    <>
      <div className={`w-full bg-linear-to-r/srgb from-[#A98700] to-[#D8C239] text-white sm:mt-6 rounded-4xl flex-col md:flex-row items-center justify-between relative overflow-hidden ${className}`}>
        <div className="text-center md:text-left p-5 md:py-0 md:px-10 space-y-7 relative z-1">
          <p className="text-2xl sm:text-3xl lg:text-[32px] font-medium text-white">Build the Future You Dream of with a Simple SIP</p>

          <div className="flex flex-col md:flex-row mx-auto md:mx-0 px-8 md:px-0 gap-4 max-w-80 md:max-w-full">
            <a href={`${ROOT_URL}start-sip.php`} className="text-sm xs:text-base border-2 border-[#ffffff80] bg-white text-[#806700] font-semibold px-4 xs:px-5 py-2 rounded-full shadow-sm hover:bg-gray-100 transition">
              Start My SIP Now
            </a>
            <TalkToExpertStripButton />
          </div>
        </div>

        {/* Right image */}
        <div className="md:mr-16 shrink-0">
          <Image src="/next_assets/images/strips/strip-start-sip-new.webp" alt="Money Plant" width={192} height={192} className="w-full h-full md:w-44 md:h-44 mx-auto blur-[2px] opacity-60 md:blur-none md:opacity-100 object-contain mix-blend-hard-light absolute inset-0 md:static z-0" />
        </div>
      </div>
    </>
  );
}
